import { FC } from 'react'

import CustomText from '../../CustomText'

type BackButtonProps = {
  label: string
  handleClick: () => void
  isBack: boolean
  children?: React.ReactNode
}

export const BackButton: FC<BackButtonProps> = ({
  handleClick,
  label,
  isBack,
  children
}: BackButtonProps) => {
  return (
    <div
      className={`w-full h-auto flex flex-row gap-y-4 items-center justify-center bg-[#FFD200] ${isBack ? 'rounded-xl' : 'rounded-full'}  gap-x-[6px] cursor-pointer px-[12px] py-[3px] active:scale-[1.02] hover:scale-[1.04]`}
      onClick={handleClick}
    >
      {children}
      <CustomText
        textLabel={label}
        fontWeight={`font-regular`}
        fontSize="text-[16px]"
        fontColor={`text-black`}
      />
    </div>
  )
}

export default BackButton
